import { createContext, use } from 'react'

/**
 * True while a settings page is hosted inside the Settings shell
 * (pages/settings-hub). The shell owns the page header and the section nav
 * (its accordion), so SettingsLayout renders only its content column and
 * pages skip their own PageContainer/PageHeader chrome.
 */
export const SettingsEmbedContext = createContext(false)

export function useSettingsEmbedded(): boolean {
  return use(SettingsEmbedContext)
}

/**
 * Section ids the Settings shell already lists in its left column for the
 * hosted group. A hosted page whose own sections are all listed there needs
 * no sub-menu of its own; one whose sections are not (a nested page such as
 * the Integrations tab of Account settings) shows them as a tab strip.
 */
export const SettingsHostedSectionsContext =
  createContext<ReadonlySet<string> | null>(null)

export function useSettingsHostedSections(): ReadonlySet<string> | null {
  return use(SettingsHostedSectionsContext)
}

/**
 * Where an admin page's own sub-navigation should point: the page is hosted
 * by the Settings shell at /settings/administration/<page>. (The former
 * admin-mode routes at /admin/<page> now redirect here.)
 */
export function useAdminPageBasePath(orgSlug: string, page: string): string {
  return `/${orgSlug}/settings/administration/${page}`
}
